import React from 'react';
import { LandingPage } from './pages/LandingPage';
export function App() {
  return <div className="min-h-screen w-full bg-[#0f0a2e] text-white overflow-x-hidden" data-id="element-0">
      <LandingPage data-id="element-1" />
    </div>;
}